import { comments } from '@/mocks/homepage';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900">用户热议</h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">看看大家都在讨论什么</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-4 md:p-5 flex gap-3 md:gap-4 hover:bg-background-200/70 transition-colors duration-200"
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden bg-background-200">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-sm font-bold text-foreground-900 whitespace-nowrap">{comment.name}</span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{comment.time}</span>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
                <div className="flex items-center gap-3 mt-2">
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-heart-line text-primary-500"></i>
                    {comment.likes.toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}